import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FuncsService {

  constructor() { }

  // Handle Errors
  error(error: HttpErrorResponse) {
    return throwError(() => {
      if(error?.error?.Errors){
        if(error?.error?.Errors.length>1)
          return error?.error?.Errors;
        else if(error?.error?.Errors[0]?.ErrorMessage=='Duplicate Pharmacy NCPDP ID.')
          return error?.error?.ResponseMessage;
        return error?.error?.Errors[0]?.ErrorMessage;
      }
      else{
        return "Internal Server Error - Please contact admin";
      }
    });
  }
}
